// extracted by mini-css-extract-plugin
export var drapery = "lensesTop-module--drapery--kRfi0";
export var draperyAndHeaderGrid = "lensesTop-module--draperyAndHeaderGrid--hX3fF";
export var draperyArticleWrapper = "lensesTop-module--draperyArticleWrapper--RI+OX";
export var draperyParagraph = "lensesTop-module--draperyParagraph--oLkGF";
export var redLine = "lensesTop-module--redLine--BXOUO";
export var theLatest = "lensesTop-module--theLatest--4Z9BK";
export var wrapper = "lensesTop-module--wrapper--YDLdK";